import { cn } from "@/lib/utils"

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      // Shimmer del DS en vez del pulse de shadcn.
      className={cn("fc-shimmer rounded-md", className)}
      {...props}
    />
  )
}

export { Skeleton }
